import React, { useState } from "react";
import InputWidget from "./InputWidget";

const EmailWidget = props => {
  return React.createElement(InputWidget, props);
};

export default EmailWidget;